import React, { useState, useEffect } from "react";
import ThemeProviderWrapper from "../../theme/ThemeProviderWrapper";
import AuthHeader from "../../components/layout/AuthHeader";
// import AuthFooter from "../../components/layout/AuthFooter";
import AuthBackground from "../../components/layout/AuthBackground";
import Step1Account from "./Step1Account";
import Step2Personal from "./Step2Personal";
import Step3Verification from "./Step3Verification";
import Step4Security from "./Step4Security";
import { useNavigate, useLocation } from "react-router-dom";
import { useSignupMutation } from "../../redux/api/authApi";
import Step5fileSubmit from "./Step5fileSubmit";
import Step5SecondfileSubmit from "./Step5SecondfileSubmit";
import { authStorageSet } from "../../utils/authStorage";

export default function SignUp() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  const [signup, { isLoading }] = useSignupMutation();

  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    setRole(queryParams.get("role"));
  }, [location.search]);

  const handleNext = (stepData = {}) => {
    setFormData((prev) => ({ ...prev, ...stepData }));
    setStep((prev) => Math.min(prev + 1, 5));
  };

  const handlePrev = () => {
    setStep((prev) => Math.max(prev - 1, 1));
  };

  // const handleFinalSubmit = async (step4Data) => {
  //   const updatedFormData = new FormData();

  //   Object.keys(formData).forEach((key) => {
  //     updatedFormData.append(key, formData[key]);
  //   });

  //   // step4Data is expected to be FormData
  //   step4Data.forEach((value, key) => {
  //     updatedFormData.append(key, value);
  //     console.warn("Key & Value  -> ", `${key}: ${value}`);
  //   });

  //   updatedFormData.append("role", role);

  //   updatedFormData.forEach((value, key) => {
  //     console.log(`${key}: ${value}`);
  //   });

  //   const payload = updatedFormData;

  //   try {
  //     await signup(payload).unwrap();
  //     navigate("/nafath");
  //     // TODO: 
  //     // navigate("/signin");
  //   } catch (err) {
  //     console.error("Signup error:", err);
  //   }
  // };

  const handleFinalSubmit = async (step4Data) => {
    const updatedFormData = new FormData();
  
    Object.keys(formData).forEach((key) => {
      updatedFormData.append(key, formData[key]);
    });
  
    step4Data.forEach((value, key) => {
      updatedFormData.append(key, value);
      console.warn("Key & Value  -> ", `${key}: ${value}`);
    });
  
    updatedFormData.append("role", role);
  
    updatedFormData.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });
  
    try {
      const response = await signup(updatedFormData).unwrap();
  
      const userId = response?.data?.userId;
  
      if (userId) {
        authStorageSet("signupUserId", userId);
      }
      if (role) {
        authStorageSet("signupRole", role);
      }

      if (role === "assetOwner") {
        navigate("/vara-verification", {
          state: { userId, role },
        });
      } else if (role === "investor") {
        navigate("/vara-verification-request-sent");
      } else {
        navigate("/");
      }
    } catch (err) {
      console.error("Signup error:", err);
    }
  };

  return (
    <ThemeProviderWrapper>
      {step === 1 ? (
        <Step1Account nextStep={handleNext} defaultValues={formData} />
      ) : (
        <AuthBackground>
          <AuthHeader />

          {step === 2 && (
            <Step2Personal
              nextStep={handleNext}
              prevStep={handlePrev}
              defaultValues={formData}
            />
          )}

          {step === 3 && (
            <Step3Verification
              nextStep={handleNext}
              prevStep={handlePrev}
              defaultValues={formData}
            />
          )}

          {/* Step 4 depends on role */}
          {step === 4 &&
            (role === "assetOwner" ? (
              <Step5SecondfileSubmit
                nextStep={handleNext}
                prevStep={handlePrev}
                defaultValues={formData}
              />
            ) : (
              <Step5fileSubmit
                nextStep={handleNext}
                prevStep={handlePrev}
                defaultValues={formData}
              />
            ))}

          {step === 5 && (
            <Step4Security
              prevStep={handlePrev}
              onSubmit={handleFinalSubmit}
              defaultValues={formData}
              isLoading={isLoading}
            />
          )}

          {/* <AuthFooter /> */}
        </AuthBackground>
      )}
    </ThemeProviderWrapper>
  );
}
